export const Get = async (path)=>{
    return await fetch(`https://pgrst.aiteditor.org/${path}`)
        .then(res => res.json())
}